<template>
  <nna-container :spacing=10>
    <div class="checkout">      
      <md-card>
        <md-card-content class="text-align-left" v-if="shopOptions.cashPayment">
          <md-radio v-model="paymentMethod" value="cash">Contanti</md-radio>
        </md-card-content>
        <md-card-content class="text-align-left" v-if="shopOptions.deposit">
          <md-radio v-model="paymentMethod" value="deposit">Wallet prepagato</md-radio>
        </md-card-content>
        <md-card-content class="text-align-left" v-if="shopOptions.card">
          <md-radio v-model="paymentMethod" value="card">Carta di credito</md-radio>    
        </md-card-content>
      </md-card>
      <div class="stripe mb-3" ref="card" v-show="paymentMethod === 'card'"></div>
      <md-field>
        <label for="note">Note</label>
        <md-textarea name="note" id="note" v-model="note" :disabled="sending" ></md-textarea>
      </md-field>      
      <div class="cart__total md-layout md-gutter mt-4 m-3">
        <div class="md-layout-item text-align-left">
          <div class="cart__totalLabel">Totale</div>
        </div>
        <div class="md-layout-item text-align-right">
          <div class="cart__totalSum">€{{total}}</div>
        </div>
      </div>
      <nna-button :loading="sending" @click.native="onCreateOrder">Concludi ordine</nna-button>
    </div>
  </nna-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { loadStripe } from '@stripe/stripe-js';
export default {
  name: 'ServicesCheckout',
  components: {      
  },
  data() {
    return {
      paymentMethod: 'cash',
      note: '',
      sending: false,
      stripe: null,
      elements: null,
      card: null,      
    }
  },
  watch: {
    paymentMethod(val) {
      if(val === 'card') this.initStripe()
    }
  },
  computed: {
    ...mapGetters({
      cart: 'cart/cart',
      shop: 'shops/current',
      order: 'cart/servicesOrder',
      total: 'cart/servicesTotal',
      current: 'shops/current',
      shopOptions: 'shops/options',
      geoPosition: 'global/geoPosition',
      reservationDateForServer: 'global/reservationDateForServer',
      stripeClientSecret: 'order/stripeClientSecret',
    })
  },
  methods: {
    ...mapActions({
      createOrder: 'order/createServicesOrder',
      getStripeClientSecretId: 'order/getStripeClientSecretId'
    }),
    watchPositionSuccess(position) {
      console.log(position)      
    },
    watchPositionError(error) {
      console.log(error)
    },
    async getPosition() {
      if(this.geoPosition && this.geoPosition.code === 2) {
        return {
          lat: 0,
          lng: 0
        }
      }
      else if(this.geoPosition && this.geoPosition.coords) {
        return {
          lat: this.geoPosition.coords.latitude,
          lng: this.geoPosition.coords.longitude
        }
      } else {            
        return new Promise((resolve, reject) => { 
          window.navigator.geolocation.getCurrentPosition(position => {
            position = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            }
            return resolve(position)
          }, this.watchPositionError)
        });
      }
    }, 
    paymentMethodSelected() {
      if(this.shopOptions.cashPayment && !this.shopOptions.deposit) this.paymentMethod = 'cash'
      else if(this.shopOptions.deposit && !this.shopOptions.cashPayment || this.shopOptions.deposit && this.shopOptions.cashPayment) this.paymentMethod = 'deposit'
    },
    async initStripe() {
      this.getStripeClientSecretId({ amount: parseFloat(this.total), stripe_pub_key: this.shop.stid_merchant })
      if(this.shop.stid_merchant) {
        this.stripe = await loadStripe(this.shop.stid_merchant);
        this.elements = this.stripe.elements();    
        this.card = this.elements.create('card');
        this.card.mount(this.$refs.card);
      }    
    },
    async purchaseStripe() {

    let stripe = this.stripe;
    let client_secter = localStorage.getItem("stripe_client_secret")

    const {token, error} = await stripe.createToken(this.card);

    let confirmCardPayment = await stripe.confirmCardPayment(client_secter, {
        payment_method: {
          card: {
            token: token.id,
          }
        }
      });   

      return confirmCardPayment
    },        
    async onCreateOrder() {
      this.sending = true
    
      try {

        //let position = await this.getPosition()
        let order = {
          //lat: position.lat,
          //lng: position.lng,
          lat: 0,
          lng: 0,
          soid: this.current.oid,
          dstart: this.reservationDateForServer,
          ptype: this.paymentMethod,
          total: this.total,
          order: this.order,
          note: this.note,          
        }

        if(this.paymentMethod === 'card') {

          let payload = await this.purchaseStripe(),
              stripe = payload.paymentIntent ? payload.paymentIntent : payload

          if(stripe.error) {
            this.sending = false
            this.$toasted.show(stripe.error.message, { type: 'error' }) 
            return;
          }

          order.stripe = stripe          
        }

        if(parseFloat(order.total) < this.shopOptions.minAmountOrder) {
          this.$toasted.show('Importo minimo non raggiunto', { type: 'info' })    
          return
        }

        if(order.ptype === 'cash') {
          if(this.shopOptions.maxCashPayment && parseFloat(order.total) > this.shopOptions.maxCashPayment) {
            this.$toasted.show('Importo massimo superato (contanti)', { type: 'info' })    
            return
          }
        }

        if(order.ptype === 'deposit') {
          if(this.shopOptions.maxDepositPayment !== null && parseFloat(order.total) > this.shopOptions.maxDepositPayment) {
            this.$toasted.show('Importo massimo superato (deposito)', { type: 'info' })    
            return
          }
        }

        const { data } = await this.createOrder(order)
        if(data.hcode === "ok") { 
          this.sending = false
          this.$router.push({ name: "checkout.done", query: { id: data.data.oid  }})
        } else {
          switch(data.code) {
            case 40012:
              this.sending = true
              this.$toasted.show('Tipologia di pagamento non accettato', { type: 'error' })    
            break;
            case 40013:
              this.sending = true
              this.$toasted.show('Importo minimo non raggiunto', { type: 'error' })    
            break;
            case 40014:
              this.sending = true
              this.$toasted.show('Importo massimo superato', { type: 'error' })    
            break;
          }
        }        
     } catch (errors) {
       this.sending = true
       console.error("Error:", errors)
       this.$toasted.show('Qualcosa è andato storto!', { type: 'error' })
      }
    },
  },
  mounted() {
    this.paymentMethod = this.shopOptions && this.shopOptions.default ? this.shopOptions.default : 'cash'
  },
}
</script>

<style lang="scss" scoped>
.StripeElement {
  box-sizing: border-box;
  height: 60px;
  padding: 21px 12px;
  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>



// WEBPACK FOOTER //
// src/modules/Shop/pages/ServicesCheckout.vue